import { Button, Card, Modal, ModalCloseButton, Section } from '@presentation/components';
import { useRouter } from '@application/utils';
import type { FC } from 'react';
import { TbArrowRight } from 'react-icons/tb';
import { FaWhatsapp } from 'react-icons/fa';
import { BREAKPOINTS } from '@presentation/styles';
import { useMediaQuery } from 'react-responsive';
import type { VetAdviceModalProps } from './types';
import * as Styled from './styled';
import IllustrationFR from './assets/vetadviceFR.webp';
import IllustrationNL from './assets/vetadviceNL.webp';

export * from './types';

const illustration = {
  fr: IllustrationFR,
  nl: IllustrationNL,
  de: IllustrationNL,
};
export const VetAdviceModal: FC<VetAdviceModalProps> = (props) => {
  const { modal, onConfirm } = props;

  const { language, translate } = useRouter();

  const buttonLabel = translate('common.modals.vetAdvice.cta');
  const title = translate('common.modals.vetAdvice.title');
  const text = translate('common.modals.vetAdvice.text');

  const isMobile = useMediaQuery({ query: `(max-width: ${BREAKPOINTS.tablet}px)` });

  return (
    <Modal {...modal}>
      <Card size="medium" isModal>
        <ModalCloseButton modal={modal} />
        <Styled.ModalSectionTitle>{title}</Styled.ModalSectionTitle>
        <Styled.Container>
          <Styled.Content dangerouslySetInnerHTML={{ __html: text }} />
          {isMobile ? (
            <Styled.ButtonContainer>
              <Button
                onClick={onConfirm}
                color="whatsappGreen"
                size="large"
                iconRight={<TbArrowRight />}
                shrink
                iconLeft={<FaWhatsapp size={20} />}
              >
                {buttonLabel}
              </Button>
            </Styled.ButtonContainer>
          ) : null}
          <Styled.IllustrationContainer>
            <Styled.Illustration
              src={illustration[language as 'fr' | 'nl']}
              alt="Phone conversation on WhatsApp"
            />
          </Styled.IllustrationContainer>
        </Styled.Container>
        {!isMobile ? (
          <Section centerChildren>
            <Button
              onClick={onConfirm}
              color="whatsappGreen"
              size="large"
              iconRight={<TbArrowRight />}
              shrink
              iconLeft={<FaWhatsapp size={20} />}
            >
              {buttonLabel}
            </Button>
          </Section>
        ) : null}
      </Card>
    </Modal>
  );
};
